const quantityFormatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 20,
});

export const formatQuantity = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' && value.trim() === '') return '';

  const numeric = Number(value);
  return Number.isFinite(numeric) ? quantityFormatter.format(numeric) : String(value);
};
